export default {
  method_unavailable: 'Este método de pago no está disponible en este momento. Elige otro.',
  payment_option_unavailable: 'Esta opción de pago no está disponible en este momento. Elige otra forma de pagar.',
  online_payment_unavailable:
    'El pago en línea no está disponible en este momento. Inténtalo de nuevo en unos instantes.',
  retry_payment_methods: 'Reintentar',
  payment_not_ready: 'Tu pago todavía se está preparando. Inténtalo de nuevo en un momento.',
  wallet_total_changed: 'El total de este método de pago ha cambiado. Compruébalo y pulsa de nuevo el botón.',
  wallet_tap_above: 'Toca el botón de {{method}} de arriba para pagar o elige otra forma de pago.',
  wallet_pay_above: 'Usa el botón de {{method}} de arriba',
  element_incomplete: 'Completa los datos de pago para continuar.',
  element_incomplete_card: 'Revisa los datos de tu tarjeta e inténtalo de nuevo.',
  element_incomplete_bank: 'Elige tu banco para continuar.',
  element_incomplete_sepa_debit: 'Revisa tu IBAN y los datos del titular de la cuenta para continuar.',
};
